import { gql } from "@apollo/client";

export const updateCompanyPolicySchedule = gql`
  mutation updateCompanyPolicySchedule($_id: MongoID!, $record:UpdateByIdCompanyPolicyScheduleInput!) {
    companyPolicySchedule_UpdateById(_id: $_id, record: $record) {
      record {
        _id
      }
    }
  }
`;


